const idr0 = new Intl.NumberFormat('id-ID', {
  style: 'currency',
  currency: 'IDR',
  maximumFractionDigits: 0,
});
const idr2 = new Intl.NumberFormat('id-ID', {
  style: 'currency',
  currency: 'IDR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
const plain = new Intl.NumberFormat('id-ID');

/** Under Rp1.000 keeps decimals. */
export function idr(value: number | string | null | undefined, forceDecimals = false): string {
  const n = Number(value ?? 0);
  if (!Number.isFinite(n)) return 'Rp0';
  if (forceDecimals || (n !== 0 && Math.abs(n) < 1000)) return idr2.format(n);
  return idr0.format(n);
}

export function num(value: number | string | null | undefined): string {
  const n = Number(value ?? 0);
  return Number.isFinite(n) ? plain.format(n) : '0';
}

/** e.g. 1.2M, 340K */
export function compact(value: number | string | null | undefined): string {
  const n = Number(value ?? 0);
  if (!Number.isFinite(n)) return '0';
  if (Math.abs(n) >= 1_000_000) return `${(n / 1_000_000).toFixed(n % 1_000_000 === 0 ? 0 : 1)}M`;
  if (Math.abs(n) >= 1_000) return `${(n / 1_000).toFixed(n % 1_000 === 0 ? 0 : 1)}K`;
  return plain.format(n);
}

export function percent(value: number | null | undefined, digits = 1): string {
  const n = Number(value ?? 0);
  return Number.isFinite(n)
    ? `${n.toLocaleString('id-ID', { minimumFractionDigits: digits, maximumFractionDigits: digits })}%`
    : '0%';
}

export function dateTime(value: string | Date | null | undefined): string {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('id-ID', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function dateShort(value: string | Date | null | undefined): string {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('id-ID', { day: '2-digit', month: 'short' });
}

export function relative(value: string | Date | null | undefined): string {
  if (!value) return 'belum pernah';
  const then = new Date(value).getTime();
  if (Number.isNaN(then)) return 'belum pernah';
  const seconds = Math.floor((Date.now() - then) / 1000);
  if (seconds < 60) return 'baru saja';
  if (seconds < 3600) return `${Math.floor(seconds / 60)} mnt lalu`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)} jam lalu`;
  if (seconds < 2592000) return `${Math.floor(seconds / 86400)} hari lalu`;
  return dateShort(value);
}

export function ms(value: number | null | undefined): string {
  if (value === null || value === undefined) return '—';
  if (value < 1000) return `${Math.round(value)}ms`;
  return `${(value / 1000).toFixed(2)}s`;
}

export function statusTone(status: string): 'good' | 'warn' | 'critical' | 'neutral' {
  switch (status?.toUpperCase()) {
    case 'ACTIVE':
    case 'COMPLETED':
    case 'HEALTHY':
    case 'PAID':
    case 'APPROVED':
    case 'MATCHED':
      return 'good';
    case 'PENDING':
    case 'DEGRADED':
    case 'STREAMING':
    case 'DRAFT':
    case 'CANCELLED':
    case 'VARIANCE':
      return 'warn';
    case 'FAILED':
    case 'REVOKED':
    case 'EXPIRED':
    case 'OUTAGE':
    case 'DISABLED':
    case 'SUSPENDED':
    case 'REJECTED':
      return 'critical';
    default:
      return 'neutral';
  }
}
